var render, staticRenderFns
import script from "./associated_position_two.vue?vue&type=script&lang=js"
export * from "./associated_position_two.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3ae9da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb3ae9da')) {
      api.createRecord('fb3ae9da', component.options)
    } else {
      api.reload('fb3ae9da', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/user_client_management/form/associated_terminals/associated_position_two.vue"
export default component.exports